import axios from 'axios'

/**
 * @typedef {Object} ProductionSiteNotesFilters
 * @property {number | null | undefined} [limit]
 * @property {number | null | undefined} [productionSiteId]
 * @property {number | null | undefined} [unreadById]
 */

/**
 * @param {string | ProductionSiteNotesFilters | undefined} [queryOrFilters]
 * @returns {string}
 */
function buildProductionSiteNotesQueryString(queryOrFilters) {
    if (!queryOrFilters) {
        return ''
    }

    if (typeof queryOrFilters === 'string') {
        return queryOrFilters
    }

    const queryParams = new URLSearchParams()

    if (queryOrFilters?.limit !== null && queryOrFilters?.limit !== undefined) {
        queryParams.set('limit', String(queryOrFilters.limit))
    }

    if (queryOrFilters?.productionSiteId !== null && queryOrFilters?.productionSiteId !== undefined) {
        queryParams.set('productionSite_id', String(queryOrFilters.productionSiteId))
    }

    if (queryOrFilters?.unreadById !== null && queryOrFilters?.unreadById !== undefined) {
        queryParams.set('unreadBy_id', String(queryOrFilters.unreadById))
    }

    return queryParams.toString()
}

class ProductionSiteNotesQueries {
    /**
     * @param {string | ProductionSiteNotesFilters | undefined} [queryOrFilters]
     */
    fetchProductionSiteNotes(queryOrFilters) {
        const queryString = buildProductionSiteNotesQueryString(queryOrFilters)
        const url = `/production-sites/production-site-notes${queryString ? `?${queryString}` : ''}`
        return axios.get(url)
    }

    fetchProductionSiteNote(id) {
        return axios.get(`/production-sites/production-site-notes/${id}`)
    }

    confirmProductionSiteNote(id) {
        return axios.post(`/production-sites/production-site-notes/${id}/confirm`)
    }

    createProductionSiteNote(payload) {
        return axios.post('/production-sites/production-site-notes', payload)
    }

    updateProductionSiteNote(id, payload) {
        return axios.put(`/production-sites/production-site-notes/${id}`, payload)
    }

    deleteProductionSiteNote(id) {
        return axios.delete(`/production-sites/production-site-notes/${id}`)
    }

    createProductionSiteNoteComment(payload) {
        return axios.post('/production-sites/production-site-note-comments', payload)
    }

    fetchUnreadProductionSiteNotes(userId) {
        return axios.get(`/production-sites/production-site-notes?unreadBy_id=${userId}`)
    }

    fetchUnreadProductionSiteNotesAmount(id) {
        return axios.get(`/production-sites/production-site-unread-notes/${id}`)
    }
}

export default new ProductionSiteNotesQueries()
